/* @flow weak */
import React from 'react';

import { dangerouslyTrackTapFromComponentInstance } from 'components/ClickEventTrigger.jsx';
import createChainedFunction from 'utils/createChainedFunction';

/**
 * This component wraps another component and adds click tracking
 * events that occur when the component is focused.
 */

type Props = {
  eventElementName?: ?string,
  eventScreenName?: ?string,
  eventProperties?: ?Object,
  children?: *,
};

class FocusEventTrigger extends React.Component {
  props: Props;

  static contextTypes = {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
    eventContextName: React.PropTypes.string,
    router: React.PropTypes.object,
  }

  render() {
    const child = React.Children.only(this.props.children);
    return React.cloneElement(child, Object.assign({}, this.props, child.props, {
      children: child.props.children,
      onFocus: createChainedFunction(() => dangerouslyTrackTapFromComponentInstance(this), child.props.onFocus),
    }));
  }
}

export default FocusEventTrigger;



// WEBPACK FOOTER //
// ./src/components/FocusEventTrigger.jsx